import { render, staticRenderFns } from "./news-list-filter.vue?vue&type=template&id=0c1172d6&"
import script from "./news-list-filter.vue?vue&type=script&lang=js&"
export * from "./news-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports